module.exports = __webpack_public_path__ + "static/media/Logo-garantias.16022632.jpg";